import React from 'react';
import { InputText, InputDate, Select } from '../../../uiComponents/common';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import FormRow from '../../../components/forms/formRow';

const toLocalDate = (value) => {
  if (!value) return undefined;
  return new Date(value.includes('T') ? value : value + 'T00:00:00');
};

const EventInfoSection = ({ restaurants, disableRestaurant = false }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.fechasEspeciales' });
  const { t: tModal } = useTranslation('translation', { keyPrefix: 'modals.createEditEvent' });
  const { watch } = useFormContext();

  return (
    <FormRow
      text={t('detail.sectionInfo.title')}
      description={t('detail.sectionInfo.description')}
      endComponent={
        <div className='col-12 col-md-8 mt-2 mb-2'>
          <div className='row'>
            <InputText
              name='name'
              label={tModal('inputName.label')}
              placeholder={tModal('inputName.placeholder')}
              isRequired={true}
              className='col-12 col-md-6'
            />
            <Select
              options={restaurants}
              label={t('detail.selectOrganization')}
              name='restaurant'
              placeholder={t('detail.selectOrganizationPlaceholder')}
              className='col-12 col-md-6'
              isDisabled={disableRestaurant}
            />
          </div>
          <div className='row mt-2'>
            <InputDate
              name='fromDate'
              label={tModal('inputDateFrom.label')}
              placeholder={tModal('inputDateFrom.placeholder')}
              isRequired={true}
              className='col-12 col-md-6'
              maxDate={toLocalDate(watch('toDate'))}
            />
            <InputDate
              name='toDate'
              label={tModal('inputDateTo.label')}
              placeholder={tModal('inputDateTo.placeholder')}
              isRequired={true}
              className='col-12 col-md-6'
              minDate={toLocalDate(watch('fromDate'))}
            />
          </div>
        </div>
      }
    />
  );
};

export default EventInfoSection;
